import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// const originalPush = Router.prototype.push
// Router.prototype.push = function push( location ){
// return originalPush.call(this, location).catch(err => err)
// }
export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Login',
      // 懒加载
      component: resolve => require.ensure([], () => resolve(require('../components/Login.vue')), 'Login')
    },
    {
      path: '/SideBar',
      name: 'SideBar',
      component: resolve => require.ensure([], () => resolve(require('../components/SideBar.vue')), 'SideBar')
    },
    {
      path: '/Login',
      name: 'Login',
      component: resolve => require.ensure([], () => resolve(require('../components/Login.vue')), 'Login')
    },
    {
      path: '/PageJump',
      name: 'PageJump',
      component: resolve => require.ensure([], () => resolve(require('../components/PageJump.vue')), 'PageJump')
    },
    {
      path: '/Index',
      name: 'Index',
      component: resolve => require.ensure([], () => resolve(require('../components/Index.vue')), 'Index'),
      children: [
        {
          path: '/Index/Home',
          name: 'Home',
          component: resolve => require.ensure([], () => resolve(require('../components/HelloWorld.vue')), 'Home')
        },
        {
          path: '/Index/OrderManger/',
          name: 'OrderManger',
          component: resolve => require.ensure([], () => resolve(require('../components/OrderManger.vue')), 'OrderManger')
        },
        {
          path: '/Index/RecordExport',
          name: 'RecordExport',
          component: resolve => require.ensure([], () => resolve(require('../components/RecordExport.vue')), 'RecordExport')
        },
        {
          path: '/Index/PersonManger/',
          name: 'PersonManger',
          component: resolve => require.ensure([], () => resolve(require('../components/PersonManger.vue')), 'PersonManger')
        },
        {
          path: '/Index/CarManger/',
          name: 'CarManger',
          component: resolve => require.ensure([], () => resolve(require('../components/CarManger.vue')), 'CarManger')
        },
        {
          path: '/Index/DeptManger/',
          name: 'DeptManger',
          component: resolve => require.ensure([], () => resolve(require('../components/DeptManger.vue')), 'DeptManger')
        },
        {
          path: '/Index/SiteManger/',
          name: 'SiteManger',
          component: resolve => require.ensure([], () => resolve(require('../components/SiteManger.vue')), 'SiteManger')
        },
        {
          path: '/Index/SiteManger/',
          name: 'SiteManger',
          component: resolve => require.ensure([], () => resolve(require('../components/SiteManger.vue')), 'SiteManger')
        },
        {
          path: '/Index/SiteManger/',
          name: 'SiteManger',
          component: resolve => require.ensure([], () => resolve(require('../components/SiteManger.vue')), 'SiteManger')
        },
        {
          path: '/Index/SpecialSite',
          name: 'SpecialSite',
          component: resolve => require.ensure([], () => resolve(require('../components/SpecialSite.vue')), 'SpecialSite')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js